export const FB_PIXEL_ID = '267337114768461';

export const pageview = () => {
  (window as any).fbq('track', 'PageView');
};

export const event = (name, options = {}) => {
  (window as any).fbq('track', name, options);
};
